<template>
<div class="row">
  <div class="col-12 small text-info">
    <span v-if="mxu.lastLogin">
    Last logged-in on <display-date :value="mxu.lastLogin"/>
    </span>
    <span v-if="mxu.locked" class="text-danger font-weight-bold ms-3">LOCKED-OUT</span>
  </div>
  <div class="col-12 text-end" v-if="mode === 'update' && formDisabled">
    <a href="#" @click="onPwReset" v-b-tooltip.hover title="Reset Password" class="me-3"><i class="fas fa-key"></i></a>
    <a href="#" @click="onEdit" v-b-tooltip.hover title="Edit"><i class="fas fa-edit"></i></a>
  </div>
  <div class="col-12">
    <form>
      <fieldset :disabled="formDisabled">
      <input-text label="User ID" v-model="mxu.userId" placeholder="enter login ID"
        :errors="errors" error-key="userId"/>
      <input-text label="First Name" v-model="mxu.firstName" placeholder="enter first name"
        :errors="errors" error-key="firstName"/>
      <input-text label="Last Name" v-model="mxu.lastName" placeholder="enter last name"
        :errors="errors" error-key="lastName"/>
      <input-text label="Email Address" v-model="mxu.emailAddress" placeholder="enter email address"
        :errors="errors" error-key="emailAddress"/>
      <input-select label="User Role" v-model="mxu.userRole" placeolder="select role">
        <option>ADMIN</option>
        <option>AGENT</option>
      </input-select>
      </fieldset>
      <p class="alert alert-warning small mt-2" v-if="mode === 'add'">Password will be auto-generated and sent to email addresss above</p>
    </form>
    <div class="text-end mt-5 mb-3" v-if="!formDisabled">
      <button class="btn btn-secondary me-2" @click="onCancel()">Cancel</button>
      <button class="btn btn-primary" @click="onSave()">Save</button>
    </div>
  </div>
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'
export default {
  name: 'MerchantUserForm',
  mixins: [HelpersMixin],
  props: {
    merchantId: String,
    merchantUser: Object
  },
  data () {
    return {
      mxu: { merchantId: this.merchantId, userId: '' },
      mode: 'add',
      formDisabled: true
    }
  },
  mounted () {
    if (this.merchantUser && this.merchantUser.userId) {
      this.mode = 'update'
      Object.assign(this.mxu, this.merchantUser)
    } else {
      this.mode = 'add'
      this.formDisabled = false
    }
  },
  methods: {
    onSave: function () {
      this.$forceUpdate()
      this.errors.clearAll()
      if (this.mode === 'add') {
        this.axios.put('/ax/mxuser', this.mxu)
        .then(() => {
          this.$emit('saved')
        })
        .catch(error => this.handleValidationErrors(error))
      }
      else {
        this.axios.post('/ax/mxuser', this.mxu)
        .then(() => {
          this.$emit('saved')
        })
        .catch(error => this.handleValidationErrors(error))
      }
    },
    onCancel: function () {
      this.$emit('cancelled')
    },
    onEdit: function () {
      this.formDisabled = false
      this.showNewPass = false
      this.newPass = ''
    },
    onPwReset: function () {
      this.$bvModal.msgBoxConfirm("Are you sure you want to reset this user's password?", {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        centered: true
      })
      .then(value => {
        console.log('confirm value: ' + value)
        if (value) {
          this.submitPwReset()
        }
      })
    },
    submitPwReset: function () {
      console.log('submitting pw reset')
      this.axios.post('/ax/mxuser/pwreset', {merchantId: this.merchantId, userId: this.mxu.userId})
      .then(() => {
        this.$toasted.success('A new password has been generated and sent to ' + this.mxu.emailAddress)
        this.$emit('saved')
      })
      .catch(error => {
        this.handleError(error)
        this.formDisabled = false
      })
    }
  }
}
</script>

